import {
    FieldInCard,
} from 'app/types/form.types'

import {
    Note,
} from '../../../ContainerNotes.types'
import {
    AuditTrailConfig, getChangeConfig,
} from './notesConfigs'

type Fields = keyof Note

const fields: FieldInCard<Fields>[] = [
    getChangeConfig(),
    AuditTrailConfig,
]

export default fields
